export const WAITLIST_ALWAYS_VISIBLE_CRM_FIELDS = new Set(["email", "postal"]);

export const CRM_DATA_FIELD_NAMES = [
  "company",
  "title",
  "firstName",
  "lastName",
  "email",
  "phone",
  "address1",
  "address2",
  "city",
  "state",
  "postal",
  "experience",
  "purchaseTimeFrame",
  "modelInterest",
  "dealer",
];

export const canHideCrmDataFieldOnWaitlist = (fieldName) =>
  !WAITLIST_ALWAYS_VISIBLE_CRM_FIELDS.has(fieldName);

export const isCrmDataFieldWaitlistHidden = (
  eventData,
  fieldName,
  registration = {},
) => {
  if (!canHideCrmDataFieldOnWaitlist(fieldName)) return false;
  if (registration?.status !== "Waitlist") return false;
  return !!eventData?.dataFields?.[fieldName]?.hideOnWaitlist;
};

export const isCrmDataFieldVisible = (
  eventData,
  fieldName,
  registration = {},
) => {
  if (isCrmDataFieldWaitlistHidden(eventData, fieldName, registration)) {
    return false;
  }
  return !!eventData?.dataFields?.[fieldName]?.visible;
};

export const isCrmDataFieldRequired = (
  eventData,
  fieldName,
  registration = {},
) =>
  isCrmDataFieldVisible(eventData, fieldName, registration) &&
  !!eventData?.dataFields?.[fieldName]?.required;

export const isCrmDataFieldShown = (
  eventData,
  fieldName,
  registration = {},
  { force = false } = {},
) => {
  if (isCrmDataFieldWaitlistHidden(eventData, fieldName, registration)) {
    return false;
  }
  return force || isCrmDataFieldVisible(eventData, fieldName, registration);
};

export const clearHiddenCrmDataFieldValues = (
  eventData,
  registration = {},
) => {
  const nextRegistration = { ...registration };

  CRM_DATA_FIELD_NAMES.forEach((fieldName) => {
    if (!isCrmDataFieldWaitlistHidden(eventData, fieldName, nextRegistration)) {
      return;
    }
    if (
      !Object.prototype.hasOwnProperty.call(nextRegistration, fieldName) ||
      nextRegistration[fieldName] === "" ||
      nextRegistration[fieldName] == null
    ) {
      return;
    }
    nextRegistration[fieldName] = "";
  });

  return nextRegistration;
};
